import styled from 'styled-components';

export const IVFCenterTopSec = styled.div`
  margin-top: ${(props) => (props.index > 0 ? '' : '122px')};
  position: relative;
  height: 480px;
  overflow: hidden;

  @media (max-width: 720px) {
    margin-top: ${(props) => (props.index > 0 ? '' : '56px')};
    height: auto;
  }
`;

export const TopBanner = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 720px) {
    transform: scale(1);
    height: 174px;
    object-fit: cover;
    margin-top: ${(props) => (props.isGeneralItem === true ? '0' : '48px')};
  }
`;

export const BannerAbsoluteSection = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;

  @media (max-width: 720px) {
    position: static;
    background-color: #f3f9f8;
    padding-bottom: 16px;
    margin-top: -4px;
  }
`;

export const BlueSection = styled.div`
  @media (max-width: 720px) {
    position: absolute;
    width: 100%;
    top: ${(props) => (props.isGeneralItem ? '18px' : '62px')};
  }
`;
export const BannerSection = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin: 0 auto;
  max-width: 1240px;
  width: 100%;
  padding: 0 20px;

  .leftSection {
    flex-basis: 70%;
    @media (max-width: 720px) {
      flex-basis: 100%;
    }
  }

  .rightSection {
    flex-basis: 30%;
    background-color: #fff;
    border-radius: 8px;
    @media (max-width: 720px) {
      flex-basis: 100%;
      order: -1;
      position: relative;
      top: -1em;
    }
  }

  @media (max-width: 720px) {
    padding: 0 10px;
    flex-wrap: wrap;
  }
`;

export const BannerPointsContainer = styled.ul`
  margin-top: 12px;
`;

export const BannerPoints = styled.li`
  font-size: 14px;
  width: 40%;
  color: #707070;
  padding: 8px 0;
  font-weight: 500;

  @media (max-width: 720px) {
    width: 100%;
  }

  .div {
    display: flex;
    align-items: flex-start;
  }
`;

export const RightTick = styled.img`
  width: 14px !important;
  height: auto;
  margin-right: 6px;
  position: relative;
  top: 3px;
`;

export const BlueColor = styled.h1`
  color: #487ca4;
  font-weight: 500;
  font-size: clamp(16px, 3vw, 30px);
  @media (max-width: 720px) {
    text-align: center;
  }
`;

export const FreeConsultant = styled.strong`
  color: #487ca4;
  font-size: clamp(18px, 3vw, 44px);
  font-weight: ${(props) => (props.bold ? '700' : '500')};
`;
